
const utils = {
    url: {
        getUrlParams = () => new URLSearchParams(window.location.search.replace(/-/g, '+')),
        checkUrlParams = (paramsToCheck = [], force) => {
            const urlParams = getUrlParams();

            const matchedParams = [];

            for (const param of paramsToCheck) {
                if (urlParams.has(param)) {
                    matchedParams.push(param);
                }
            }

            return matchedParams.length > 0 || force ? urlParams : null;
        },
        parseAndTransform = (item, attribute) => {
            if (!item || !item.hasAttribute(attribute)) {
                console.error(`Attribute ${attribute} not found on item`);
                return [];
            }

            try {
                const data = JSON.parse(item.getAttribute(attribute) || '[]');
                // Replace spaces to dashes and also if trailing dash make it a + 
                // (This is due to Friskis rarely but sometimes have + signs as a trailing characther)
                return data.map(str => decodeURIComponent(str.toLowerCase().replace(/\s+/g, '-')));
            } catch (error) {
                console.error(`Failed to parse JSON for attribute ${attribute}:`, error);
                return [];
            }
        },

        decodedUrl = (url) => { return `${window.location.pathname}?${decodeURIComponent(url.toString().replace(/\+/g, '-'))}` },

        // For singular url Params -- replace value on change
         updateURLParamSingle = (param, value) => {
            const url = new URL(window.location);
            if (value) {
                url.searchParams.set(param, value);
            } else {
                url.searchParams.delete(param);
            }
            window.history.replaceState(null, '', url);
        },

        // For url with multiple -- ex. city=jonkoping,stockholm etc--
        updateURLParameter = (urlParams, param, value, isChecked) => {
            let paramValues = urlParams.get(param) ? urlParams.get(param).split(',') : [];
            if (isChecked) {
                if (!paramValues.includes(value)) {
                    paramValues.push(value);
                }
            } else {
                paramValues = paramValues.filter(v => v !== value);
            }

            if (paramValues.length > 0) {
                urlParams.set(param, paramValues.join(','));
            } else {
                urlParams.delete(param);
            }
        },
        getPrefix = () => {
            const path = window.location.pathname;

            const segments = path.split('/').filter(segment => segment.length > 0);

            let languagePrefix = '';
            if (segments.length > 0 && segments[0].length === 5 && segments[0][2] === '-') {
                languagePrefix = segments[0];
            }
            return languagePrefix;
        },
    },
    currency: {
        formatCurrency = (amount, currency = 'SEK', locale = 'sv-SE') => {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency
            }).format(amount);
        }
    },
    modal: {
        trapFocus = (element) => {
            const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const firstFocusableElement = element.querySelectorAll(focusableElements)[0];
            const focusableContent = element.querySelectorAll(focusableElements);
            const lastFocusableElement = focusableContent[focusableContent.length - 1];

            document.addEventListener('keydown', function (e) {
                let isTabPressed = e.key === 'Tab' || e.key === 9;

                if (!isTabPressed) {
                    return;
                }

                if (e.shiftKey) { // if shift key pressed for shift + tab combination
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                } else { // if tab key is pressed
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            });

            // To land the first tab inside the trappedFocus & immediately remove it for styling purposes
            firstFocusableElement.focus();
            firstFocusableElement.blur();
        },

        removeTrapFocus = () => {
            document.removeEventListener('keydown', trapFocus);
        },
    },
    common: {
        applyCheckboxToggle = (container, threshold = 10) => {
            if (!container || typeof lucide === "undefined") {
                console.error("Lucide is not loaded or container is missing.");
                return;
            }

            const divContainers = container.querySelectorAll("div"); // Parent divs containing <ul> and <button>
            divContainers.forEach((div) => {
                const ul = div.querySelector("ul"); // Select the <ul> inside the div
                const toggleButton = div.querySelector("button"); // Select the button in the same div

                const checkboxes = ul.querySelectorAll('input[type="checkbox"]');
                if (checkboxes.length <= threshold) {
                    // Hide the button if items are under or equal to threshold
                    toggleButton.style.display = "none";
                    return;
                }

                let isOpen = false; // Track visibility state

                // Initial hide for items exceeding the threshold
                checkboxes.forEach((checkbox, idx) => {
                    if (idx >= threshold) checkbox.closest("li").style.display = "none";
                });

                // Get text from data attributes
                const showMoreText = toggleButton.dataset.showMore || "Visa mer";
                const showLessText = toggleButton.dataset.showLess || "Visa mindre";

                // Event listener for toggle button
                toggleButton.addEventListener("click", () => {
                    isOpen = !isOpen;

                    // Toggle visibility for checkboxes
                    checkboxes.forEach((checkbox, idx) => {
                        checkbox.closest("li").style.display =
                            idx >= threshold && !isOpen ? "none" : "flex";
                    });

                    // Update button text
                    toggleButton.querySelector("span").innerText = isOpen
                        ? showLessText
                        : showMoreText;

                    // Rotate the chevron icon
                    toggleButton.querySelector("svg").style.transform = isOpen ? "rotate(180deg)" : "rotate(0deg)";
                });
            });
        },
        showElement = (element) => element?.classList.remove('hidden'),
        hideElement = (element) => element?.classList.add('hidden'),
        showMoreItems = (amountToShow = 10, button, listItems, showAll = false) => {
            const itemsToShow = amountToShow;
            let visibleItems = itemsToShow;
            const showItems = (count) => {
                listItems.forEach((item, index) => {
                    if (index < count) {
                        utils.common.showElement(item);
                    } else {
                        utils.common.hideElement(item);
                    }
                });
            };

            const showAllItems = () => {
                listItems.forEach((item) => {
                    utils.common.showElement(item);
                });
                button.style.display = "none";
            }

            showItems(visibleItems);

            if (button) {
                button.addEventListener('click', () => {
                    if (showAll) {
                        showAllItems()
                    } else {
                        visibleItems += itemsToShow;
                        showItems(visibleItems);

                        if (visibleItems >= listItems.length) {
                            button.style.display = "none";
                        }
                    }
                });
            }
        },
        updateFilterButton = (count, counterSpan) => {
            if (counterSpan) {
                counterSpan.setAttribute('data-filter-count', count);
                counterSpan.textContent = `${count}`;

                if (count > 0) {
                    utils.common.showElement(counterSpan);
                } else {
                    utils.common.hideElement(counterSpan);
                }
            }
        }
    },
    "google-maps": {
        // Function to calculate the distance between two lat/long points -- ChatGpt generated ---
         calculateDistance = (lat1, long1, lat2, long2) => {
            const R = 6371; // Earth's radius in kilometers
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLong = (long2 - long1) * Math.PI / 180;

            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c; // Distance in kilometers
        }
    }

}




